import {
  Box,
  Column,
  Columns,
  Text,
  useResponsiveValue,
} from 'braid-design-system';
import type { FC } from 'react';

import Answers from 'src/components/list/JobApplicationCard/RoleRequirementsView/RoleRequirement/Answers';
import { RoleRequirementIconWithTooltip } from 'src/components/list/JobApplicationCard/RoleRequirementsView/RoleRequirement/RoleRequirementCredentialTooltip/RoleRequirementIconWithToolTip';

export interface RoleRequirementProps {
  isMobile: boolean;
  jobApplicationId: string;
  roleRequirement: {
    question: string;
    status: string;
    showVerifiedTagInAnswers: boolean;
    answers: Array<{ id: string; text: string; isVerified: boolean }>;
    verifications: Array<{
      title: string;
      credentialInfo: Array<{ name: string; values: string[] }>;
    }>;
  };
  hasOnlyCustomQuestions: boolean;
  isFilterExpand: boolean;
}

export const RoleRequirement: FC<RoleRequirementProps> = ({
  isMobile,
  jobApplicationId,
  roleRequirement: {
    question,
    status,
    showVerifiedTagInAnswers,
    answers,
    verifications,
  },
  hasOnlyCustomQuestions,
  isFilterExpand,
}) => {
  const responsiveValue = useResponsiveValue();

  const shouldShowCollapseView = responsiveValue({
    mobile: true,
    tablet: isFilterExpand,
    desktop: false,
    wide: false,
  });

  const shouldShowEqualWidthColumn = responsiveValue({
    mobile: false,
    tablet: !isFilterExpand,
    desktop: isFilterExpand,
    wide: false,
  });

  if (shouldShowCollapseView) {
    return (
      <Box data-cy="role-requirement">
        <Columns space="xxsmall" align="left" alignY="top">
          <Column width="content">
            {!hasOnlyCustomQuestions ? (
              <RoleRequirementIconWithTooltip
                jobApplicationId={jobApplicationId}
                verifications={verifications}
                status={status}
                isCardView
                isMobile={isMobile}
              />
            ) : null}
          </Column>
          <Column>
            <Box data-cy="question">
              <Text size="small">{question}</Text>
            </Box>
          </Column>
        </Columns>
      </Box>
    );
  }

  return (
    <Box data-cy="role-requirement">
      <Columns space="large">
        <Column width={shouldShowEqualWidthColumn ? '1/2' : '1/3'}>
          <Box data-cy="question">
            <Text size="small">{question}</Text>
          </Box>
        </Column>
        <Column width={shouldShowEqualWidthColumn ? '1/2' : '2/3'}>
          <Columns space="xxsmall" align="left" alignY="top">
            <Column width="content">
              {!hasOnlyCustomQuestions ? (
                <RoleRequirementIconWithTooltip
                  jobApplicationId={jobApplicationId}
                  verifications={verifications}
                  status={status}
                  isCardView
                  isMobile={isMobile}
                />
              ) : null}
            </Column>
            <Column>
              <Answers
                answers={answers}
                showVerifiedTagInAnswers={showVerifiedTagInAnswers}
                isCardView
                verifications={verifications}
                jobApplicationId={jobApplicationId}
                status={status}
                size="small"
              />
            </Column>
          </Columns>
        </Column>
      </Columns>
    </Box>
  );
};
